import {env} from './EnvironmentConfig'

export const API_BASE_URL = env.API_ENDPOINT_URL
export const ASSET_BASE_URL = env.ASSET_ENDPOINT_URL
export const WEB_BASE_URL = env.WEB_URL
export const ENV = env.ENV